import React, { useState } from "react";
// import { FiEdit2, FiTrash2, FiFilter } from "react-icons/fi";
import { Tabs, Tab } from "react-bootstrap";
import Course from "../../Components/UserConfigure/Course/Course";
import "../../styles/UserConfiguration.css";
// import ProfessorList from "../../Components/UserConfigure/Professor/ProfessorList";
// import Schedule from "../../Components/UserConfigure/Schedule";
import Student from "../../Components/UserConfigure/Student";

const UserConfiguration = () => {
  const [key, setKey] = useState("courses");

  return (
    <aside className="mainSection">
      <div className="p-4">
        <h4 className="h3Title mb-4 mt-5">User Configuration</h4>

        <div className="customeTabBox border rounded bg-white">
          <Tabs
            className="tabBox"
            id="user-config-tabs"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="courses" title="Courses">
              <Course />
            </Tab>
            {/* <Tab eventKey="professors" title="Professors"><ProfessorList /></Tab> */}
            {/* <Tab eventKey="schedule" title="Schedule"><Schedule /></Tab> */}
            <Tab eventKey="student" title="Student">
              <Student />
            </Tab>
          </Tabs>
        </div>
      </div>
    </aside>
  );
};

export default UserConfiguration;
